import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { FehApiEffects } from './feh.ngrx-wrapper';
import { UtilApiEffects } from './util.ngrx-wrapper';
import { MeteringApiEffects } from './metering.ngrx-wrapper';

@NgModule({
  imports: [
    EffectsModule.forFeature(FehApiEffects, UtilApiEffects, MeteringApiEffects),
  ],
})
export class FehSharedApiStoreModule {}
